import React, {useState} from 'react'
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, ButtonType, Card, Colors, ButtonTier} from '../index';
import {logger} from '../../utilities';
import clsx from 'clsx';
import './Modal.scss';

const LOG_PREFIX = '[EmailModal.js]';

const EmailModal = (props) => {
    logger.debug(LOG_PREFIX, '.render', {...props});
    const {
        customerEmail,
        offeringNames,
        onSend,
        onClear,
        onAdd,
        onClick,
        onDelete,
        toggleClosed,
        sentOfferings
    } = props;
    const generateOfferings = () => (
        <div className={'offeringList'}>
            {offeringNames.map((o, i) => (
                    <div className={'offeringItem'} key={i}>
                        <p onClick={() => {
                            toggleClosed();
                            onClick(o)
                        }}>{o}</p>
                        <div className={'deleteButton'} onClick={() => onDelete(o)}>
                            <FontAwesomeIcon className='btn-icon' icon={faTrashAlt}/>
                        </div>
                    </div>
                )
            )}
        </div>
    );
    return (
        <div className={'Modal--background'}>
            <div className={'closeArea'} onClick={toggleClosed}/>
            <Card className={clsx('Modal', 'EmailModal')}>
                <div>
                    <span>
                        <h2>{`${sentOfferings ? 'Successfully Emailed Offerings!' : 'Email Offerings'}`}</h2>
                            <Button
                                label={'Close'}
                                className={'exitButton'}
                                onClick={toggleClosed}
                                type={ButtonType.Reset}
                            />
                     </span>
                    <p>View, add, or remove offerings to: <em>{customerEmail}</em></p>
                    <p>Add offerings below, click the trash icon to remove and click the title to quickly navigates to
                        it.</p>
                </div>
                <div>
                    {(offeringNames.length === 0) ?
                        <em>No Offerings Selected</em>
                        :
                        generateOfferings()
                    }
                </div>
                <div>
                    <Button
                        label={'Clear'}
                        onClick={onClear}
                        type={ButtonType.Remove}
                        colorTheme={Colors.Grey}
                        tier={ButtonTier.Tertiary}

                    />
                    <div>
                        <Button
                            label={'Add'}
                            onClick={onAdd}
                            type={ButtonType.Add}
                            tier={ButtonTier.Secondary}
                        />
                        <Button
                            label={'Email List'}
                            onClick={onSend}
                            disabled={offeringNames.length < 1}
                            type={ButtonType.Email}
                            colorTheme={Colors.Orange}
                        />
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default EmailModal